import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import 'react-table/react-table.css';
import { translate } from 'react-i18next';
import moment from 'moment';

import { dateFromISO } from '../utils/helpers';
import ReactTable from 'react-table';
import * as endUserActions from '../redux/modules/endUsers';
import i18n from '../translations/i18n';

/*
PropTypes / DefaultProps
 */
const defaultProps = {
  loading: false,
};

const propTypes = {
  loading: PropTypes.bool,
  t: PropTypes.func,
};

class UserDevices extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      devices: null,
    };
  }
  /*
    Lifecycle methods
   */
  componentWillMount() {
    this.props.fetchDevicesByEndUser(this.props.endUserId);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.devices) {
      this.setState({
        devices: nextProps.devices,
      });
    }
  }

  /*
    Custom methods
   */

  initColumns() {
    this.columns = [
      {
        header: this.props.t('device_os'),
        accessor: 'device_os',
        className: 'centerAlign',
        hideFilter: true,
        sortable: false,
      },
      {
        header: this.props.t('device'),
        accessor: 'meta.device',
        className: 'centerAlign',
        hideFilter: true,
        sortable: false,
      },
      {
        header: this.props.t('device_model'),
        accessor: 'meta.deviceModel',
        className: 'centerAlign',
        hideFilter: true,
        sortable: false,
      },
      {
        header: this.props.t('manufacturer'),
        accessor: 'meta.manufacturer',
        className: 'centerAlign',
        hideFilter: true,
        sortable: false,
      },
      {
        header: this.props.t('os_release'),
        accessor: 'meta.os_release',
        className: 'centerAlign',
        hideFilter: true,
        sortable: false,
      },
      {
        header: this.props.t('sdk'),
        accessor: 'meta.sdk_int',
        className: 'centerAlign',
        hideFilter: true,
        sortable: false,
      },
      {
        header: this.props.t('application_version'),
        accessor: 'meta.applicationVersion',
        className: 'centerAlign',
        hideFilter: true,
        sortable: false,
      },
      {
        header: this.props.t('last_modified'),
        accessor: 'lastModified',
        className: 'centerAlign',
        render: row => dateFromISO(row.value),
        hideFilter: true,
        sortable: false,
      },
      {
        header: this.props.t('time_created'),
        accessor: 'timeCreated',
        className: 'centerAlign',
        render: row => dateFromISO(row.value),
        hideFilter: true,
        sortable: false,
      },
    ];
  }

  fetchData = () => {
    this.props.fetchDevicesByEndUser(this.props.endUserId);
  };

  isJson = item => {
    item = typeof item !== "string"
        ? JSON.stringify(item)
        : item;

    try {
        item = JSON.parse(item);
    } catch (e) {
        return false;
    }

    if (typeof item === "object" && item !== null) {
        return true;
    }

    return false;
}

  render() {
    this.initColumns();

    let data = [];
    if (this.props.devices) {
      this.props.devices.forEach(device => {
        if (this.isJson(device.metadata)) {

          const textObject = JSON.parse(device.metadata);
          if (Array.isArray(textObject)) {
            device.meta = textObject[0];
          } else {
            device.meta = textObject;
          }
        }
        data.push(device);
      });

      data.sort((a, b) => moment(b.lastModified) - moment(a.lastModified)).filter((prop, index) => index < 5);
    }

    return (
      <ReactTable
        data={data}
        loading={this.props.loading}
        columns={this.columns}
        onChange={this.fetchData}
        defaultPageSize={3}
        showPagination={false}
        noDataText={this.props.t('user_no_paketbox_assigned')}
        pageSize={data.length < 5 ? 5 : data.length}
      />
    );
  }
}

UserDevices.defaultProps = defaultProps;
UserDevices.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    devices: state.endUsers.devices,
  };
}

const actions = Object.assign({}, endUserActions);

const extended = translate(['translations'], { i18n })(UserDevices);
export default connect(mapStateToProps, actions)(extended);



// WEBPACK FOOTER //
// ./src/components/UserDevices.js